import { render, staticRenderFns } from "./tab-1p1c.vue?vue&type=template&id=5c611ba1&"
import script from "./tab-1p1c.vue?vue&type=script&lang=js&"
export * from "./tab-1p1c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c611ba1')) {
      api.createRecord('5c611ba1', component.options)
    } else {
      api.reload('5c611ba1', component.options)
    }
    module.hot.accept("./tab-1p1c.vue?vue&type=template&id=5c611ba1&", function () {
      api.rerender('5c611ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/results-pages/tabs/tab-1p1c.vue"
export default component.exports